import React from "react";
import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

export default function LegalFirewall() {
  const bad = [
    "Texts your customers on your behalf",
    "TCPA + CAN-SPAM exposure on every send",
    "Class-action risk on every wrong number",
    "Customer relationship gets diluted by a bot",
  ];
  const good = [
    "Zero outbound. We never message anyone.",
    "Zero TCPA exposure. Zero CAN-SPAM exposure.",
    "Lawyer can approve LeadRiver in five minutes.",
    "Every touchpoint is owned by you, in your voice.",
  ];

  return (
    <section
      id="firewall"
      data-testid="legal-firewall-section"
      className="bg-[#0B3D5C] text-[#FAF7F2] py-24 sm:py-32 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none"
           style={{ backgroundImage: "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
      <div className="max-w-7xl mx-auto px-6 relative">
        <p className="kicker" style={{ color: "#E07B3A" }}>The Firewall</p>
        <h2 className="h-section text-[clamp(2rem,4.4vw,3.6rem)] mt-5 max-w-4xl text-white">
          We never contact your customers. That's the product.
        </h2>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="compare-col bad text-[#1A1A1A]"
            data-testid="firewall-bad-col"
          >
            <p className="kicker text-[#7A2E2E]">Other AI tools</p>
            <h3 className="h-card mt-3 text-[1.6rem]">They send. You hope.</h3>
            <ul className="mt-6 space-y-3 font-serif-body text-[1rem] text-[#1A1A1A]">
              {bad.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <X size={18} className="mt-1 text-[#7A2E2E]" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="compare-col good"
            data-testid="firewall-good-col"
          >
            <p className="kicker">LeadRiver</p>
            <h3 className="h-card mt-3 text-[1.6rem] text-white">
              You send. We don't.
            </h3>
            <ul className="mt-6 space-y-3 font-serif-body text-[1rem] text-[#FAF7F2]/95">
              {good.map((g) => (
                <li key={g} className="flex items-start gap-3">
                  <Check size={18} className="check mt-1" />
                  <span>{g}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <p className="font-serif-body text-[1.15rem] mt-12 max-w-3xl text-[#FAF7F2]/85 leading-relaxed">
          That restriction is the product. It's why a careful owner can run us
          at scale without a single worry.
        </p>
      </div>
    </section>
  );
}
